module.exports = __webpack_public_path__ + "static/media/location-image-dumb.7c2794b5.jpg";